import { TreeDataNode } from 'antd';

import { Category, Document } from 'interfaces/documents';
import { isCategory, ROOT_FOLDER_ID } from 'utilities/constants';

// The folder an item lives in: its parent for a folder, its category for a file.
export const containingFolderOf = (item: Category | Document): number =>
    Number((isCategory(item) ? item.parent_id : item.category_id) ?? ROOT_FOLDER_ID);

export const containingFoldersOf = (items: (Category | Document)[]): number[] => items.map(containingFolderOf);

// The keys rc-tree need not lazily load, i.e. those whose children are present.
// A node left childless by a refresh drops out, which is what lets rc-tree fetch
// it again — it otherwise refuses to reload a key it has loaded once.
export const collectLoadedKeys = (nodes: TreeDataNode[], into: TreeDataNode['key'][] = []): TreeDataNode['key'][] => {
    nodes.forEach((node) => {
        if (!node.children?.length) return;

        into.push(node.key);
        collectLoadedKeys(node.children, into);
    });
    return into;
};

// Wrapped rather than returned bare so an absent node (null) stays distinguishable
// from the root, whose parentKey legitimately is null.
export const findNodeParentKey = (
    nodes: TreeDataNode[],
    key: number,
    parentKey: number | null = null,
): { parentKey: number | null } | null => {
    for (const node of nodes) {
        if (Number(node.key) === key) return { parentKey };

        const found = node.children ? findNodeParentKey(node.children, key, Number(node.key)) : null;
        if (found) return found;
    }
    return null;
};
